var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeSlotIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4875 3.65414C15.517 6.21637 15.503 9.84203 13.4539 12.3885L12.9083 11.9496C15.0156 9.33306 14.7012 5.52369 12.1933 3.28809C9.68542 1.05249 5.86509 1.17598 3.50682 3.56887C1.14854 5.96176 1.08074 9.78348 3.35265 12.2585C5.62455 14.7336 9.4381 14.9925 12.0237 12.8472L12.4708 13.3859C11.214 14.4284 9.6327 14.9993 7.99987 15C4.73128 14.9997 1.89801 12.7374 1.17438 9.5499C0.450759 6.36242 2.02944 3.09846 4.97751 1.68688C7.92558 0.275289 11.4581 1.0919 13.4875 3.65414ZM7.64915 3.80036L8.34919 3.80176L8.34009 7.91588L10.807 11.0149L10.2596 11.4511L7.63935 8.15879L7.64915 3.80036Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSlotIcon);
export default __webpack_public_path__ + "static/media/time-slot-icon.815743d67a0d9b0db65cc3c8411adc7585d7d95804b6924fd55be9e181547f53.svg";
export { ForwardRef as ReactComponent };